import * as features from './features';

export const aliases = [...Object.values(features)];
